export const SceneMimeTypes = {

    // mains
    Player: 'mainPlayer',   // mime of mainPlayer or empty string '' are essentially the same thing and means it can be assigned to a remote player
    Scene: 'scene',         // when mime is 'scene' the scene can be dragged on to scheduler

    // mimes
    Calendar: 'Json.calendar',
    Catalog: 'Catalog',
    CustomRss: 'CustomRss',
    DropBox: 'Json.dropbox',
    Facebook: 'Json.facebook',
    FacebookGroups: 'Json.facebook.groups',
    Flickr: 'Json.flickr',
    GoogleBusiness: 'Json.google.business',
    GoogleDrive: 'Json.drive',
    IFTTT: 'Json.ifttt',
    Instagram: 'Json.instagram',
    InstagramFeed: 'Json.instagram.feed',
    InstagramMedia: 'Json.instagram.media',
    LinkedIn: 'Json.linkedin',
    Pinterest: 'Json.pinterest',
    Reddit: 'Json.reddit',
    Spreadsheet: 'Json.spreadsheet',
    Stocks: 'Stocks',
    Telegram: 'Json.telegram',
    TikTok: 'Json.tiktok',
    Weather: 'Json.weather',
    XML: 'XML',
    YouTube: 'Json.youtube',
    X: 'Json.X',

    // disabled
    TumblrTexts: 'Json.tumblr.texts',
    TumblrPhotos: 'Json.tumblr.photos',
    TumblrVideos: 'Json.tumblr.videos',
    TumblrPosts: 'Json.tumblr.posts',
    YelpReviews: 'Json.yelp.reviews',
    YelpInfo: 'Json.yelp.info',
    FiveHundredCollection: 'Json.500px.collection',
    FiveHundredUser: 'Json.500px.user',
    EtsyProfile: 'Json.etsy.userProfile',
    EtsyShop: 'Json.etsy.shopAbout',
    EtsyListing: 'Json.etsy.shopListings',
    FacebookVideo: 'Json.facebook.videos',
    FacebookAlbum: 'Json.facebook.album',
    FacebookWall: 'Json.facebook.wall',
    PinterestBoard: 'Json.pinterest.board',
    PinterestUser: 'Json.pinterest.user',
    Twitter: 'Json.twitter',
};

// NetFeedNews: 'Json.netfeed.news',
// NetFeedHoroscope: 'Json.netfeed.horoscope'
